export const COLORS = {
  backgroundGreen: 'rgba(36, 180, 126, 1)',
  backgroundOffsetOnLight: 'rgba(245, 246, 248, 1)',
  borderOnLight: 'rgba(26, 26, 26, 0.1)',
  borderSelected: 'rgba(23, 23, 23, 1)',
  borderSubduedOnLight: 'rgba(26, 26, 26, 0.05)',
  defaultBackgroundColor: '#ffffff',
  defaultButtonColor: '#0074d4',
  defaultLinkButtonColor: '#00D66F',
  offsetOnLight: 'rgba(26, 26, 26, 0.04)',
  offsetHoverOnLight: 'rgba(26, 26, 26, 0.08)',
  textDisabled: 'rgba(26, 26, 26, 0.5)',
  textDisabledOnDark: 'rgba(255, 255, 255, 0.5)',
  textDisabledOnLight: 'rgba(26, 26, 26, 0.5)',
  textPrimary: 'rgba(26, 26, 26, 1)',
  textPrimaryOnDark: 'rgba(255, 255, 255, 1)',
  textSecondary: 'rgba(64, 64, 64, 1)',
  textSubduedOnDark: 'rgba(255, 255, 255, 0.7)',
  textSubduedOnLight: 'rgba(26, 26, 26, 0.7)',
  textMutedOnLight: 'rgba(26, 26, 26, 0.20)',
  errorBackground: 'rgba(220, 39, 39, 0.04)',
  communicationCritical: 'rgba(220, 39, 39, 1)',
  textFeedbackSuccess: '#217005',
  warningBackground: 'rgba(254, 251, 231, 1)',
  communicationWarning: 'rgba(187, 85, 4, 1)',
  infoBackground: 'rgba(245, 246, 248, 1)',
  communicationInfo: 'rgba(99, 115, 129, 1)',
  backgroundFeedbackSuccess: 'rgba(209, 250, 179, 1)',
  backgroundNeutral: 'rgba(0, 0, 0, 0.06)',
  iconDefault: '#3C4F69',
  backgroundFeedbackCritical: 'rgba(253, 233, 238, 1)',
  iconFeedbackCritical: 'rgba(230, 25, 71, 1)',
  overlayBackground: 'rgba(255, 255, 255, 0.85)',
};
